<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.TradeDetail')"
      width="960px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="grid-view">
        <div class="main-content">
          <div style="display: flex">
            <span>{{ $t('SeaExport.ContainerSize') }}：{{ containerInfo.eqSize + containerInfo.eqType }}</span>
            <span style="margin-left: 10px">{{ $t('SeaExport.ContainerNo') }}：{{ containerInfo.containerNo }}</span>
            <span style="margin-left: 10px">{{ $t('SeaExport.SealNo') }}：{{ containerInfo.sealNo }}</span>
          </div>
          <div class="triggers" style="margin-top: 10px">
            <el-button type="primary" no="1" @click="chooseGoodsBtnClickHandler">{{ $t('SeaExport.ChooseGoods') }}</el-button>
            <el-button type="danger" no="2" @click="removeOrderBtnHandler">{{ $t('SeaExport.RemoveTheGoods') }}</el-button>
            <el-radio-group v-model="selectOrderWindow.goodsMode" style="margin-left: 30px" @change="toQuery">
              <el-radio :label="SystemConstants.FCL_TYPE.code" :disabled="lcl.rowData.length > 0 || console.rowData.length > 0">{{ $t('SeaExport.FclOrderType') }}</el-radio>
              <el-radio :label="SystemConstants.LCL_TYPE.code" :disabled="fcl.rowData.length > 0 || console.rowData.length > 0">{{ $t('SeaExport.LclOrderType') }}</el-radio>
              <el-radio :label="SystemConstants.CONSOLE_TYPE.code" :disabled="fcl.rowData.length > 0 || lcl.rowData.length > 0">{{ $t('SeaExport.ConsoleOrderType') }}</el-radio>
            </el-radio-group>
            <div v-show="selectOrderWindow.goodsMode === SystemConstants.LCL_TYPE.code" class="calculation" style="float: right">
              <span>{{ totalLabel.TotalPacking }}  {{ totalDesc.estimatedTotalPackings }} / {{ totalDesc.totalPackings }}</span>
              <span>{{ totalLabel.TotalCubage }}  {{ totalDesc.estimatedTotalCubages }} / {{ totalDesc.totalCubages }}</span>
              <span>{{ totalLabel.TotalWeight2 }}  {{ totalDesc.estimatedTotalWeight }} / {{ totalDesc.totalWeight }}</span>
            </div>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              v-show="selectOrderWindow.goodsMode === SystemConstants.FCL_TYPE.code"
              config-module="130147"
              :grid-options="fcl.gridOptions"
              :column-defs="fcl.columnDefs"
              :row-data="fcl.rowData"
              style="width:100%;height:200px;margin-top:5px"
              @gridReady="onFclGridReady"
            />
            <cargo-ag-grid
              v-show="selectOrderWindow.goodsMode === SystemConstants.LCL_TYPE.code"
              config-module="130131"
              :grid-options="lcl.gridOptions"
              :column-defs="lcl.columnDefs"
              :row-data="lcl.rowData"
              style="width:100%;height:200px;margin-top:5px"
              @gridReady="onLclGridReady"
            />
            <cargo-ag-grid
              v-show="selectOrderWindow.goodsMode === SystemConstants.CONSOLE_TYPE.code"
              config-module="130148"
              :grid-options="console.gridOptions"
              :column-defs="console.columnDefs"
              :row-data="console.rowData"
              style="width:100%;height:200px;margin-top:5px"
              @gridReady="onConsoleGridReady"
            />
          </div>
        </div>
      </div>
      <span slot="footer" style="padding:10px">
        <el-button type="primary" no="3" @click="saveHandler">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button no="4" @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 查看编辑货物信息弹窗 -->
    <trade-detail-select-order-window
      :visible.sync="selectOrderWindow.visible"
      :goods-mode="selectOrderWindow.goodsMode"
      :cargo-doc="cargoDoc"
      :container-info="containerInfo"
      @reloadTable="reloadTable"
    />
  </div>
</template>

<script>

import {
  queryPoPackageListWithTotalPoPackage,
  batchRemoveEdiContainerPackage,
  savePackageInfo,
  queryOrderListByContainerCargoDoc,
  batchModifyEdiContainerPoInfo,
  queryOrderListByConsoleContainer
} from '@/api/seaExport/container'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import TradeDetailSelectOrderWindow from '@/views/cargo/v0/Clearing/components/booking/TradeDetailSelectOrderWindow'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TradeDetailWindow',
  components: { TradeDetailSelectOrderWindow },
  props: {
    visible: { type: Boolean, required: true },
    containerInfo: { type: Object, required: true, default: () => {} },
    cargoDoc: { type: Object, required: true, default: () => {} }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridParams: {},
      fcl: {
        gridOptions: {
          rowSelection: 'multiple'
        },
        gridApi: {},
        rowData: [],
        columnDefs: [
          {
            headerName: '', width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true,
            checkboxSelection: (item) => {
              const { data } = item
              if (!data.poNo) {
                return false
              }
              return true
            }
          },
          { headerName: this.$t('SeaExport.OrderNo2'), field: 'poNo', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerSize'), field: 'eqSize', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerRule'), field: 'eqType', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 100 },
          { headerName: this.$t('SeaExport.ContainerNo'), field: 'containerNo', width: 150 },
          {
            headerName: this.$t('SeaExport.Supplier'),
            field: 'supplierId',
            colId: 'supplierId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Source'), field: 'source', width: 150 }
        ]
      },
      lcl: {
        gridApi: {},
        gridOptions: {
          rowSelection: 'multiple'
        },
        rowData: [],
        columnDefs: [
          {
            headerName: '', width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true,
            checkboxSelection: (item) => {
              const { data } = item
              if (!data.packageNo) {
                return false
              }
              return true
            }
          },
          { headerName: this.$t('SeaExport.PackageNo'), field: 'packageNo', colId: 'packageNo', width: 150 },
          { headerName: this.$t('SeaExport.OrderNo2'), field: 'poNo', width: 150 },
          { headerName: 'SKU ' + this.$t('SeaExport.Code3'), field: 'itemNo', width: 150 },
          { headerName: 'SKU ' + this.$t('SeaExport.Quantity2'), field: 'skuNum', width: 150 },
          { headerName: this.$t('SeaExport.NumberOfCartons'), field: 'cartonNum', width: 150 },
          { headerName: this.$t('SeaExport.PackageType'), field: 'packageType', width: 150 },
          {
            headerName: this.$t('SeaExport.NumberOfPackages'), field: 'numberOfPackages', width: 150,
            cellRenderer: (item) => {
              const { data } = item
              return `<span style="color:blue">${data.estimatedNumberOfPackages}</span> /
                       <span style="color:blue">${data.numberOfPackages}</span>`
            }
          },
          {
            headerName: this.$t('SeaExport.Weight') + '(KGS)', field: 'weight', width: 150,
            cellRenderer: (item) => {
              const { data } = item
              const estimatedWeight = ColumnUtils.number3ColumnLabelFunc(data.estimatedWeight)
              const weight = ColumnUtils.number3ColumnLabelFunc(data.weight)
              return `<span style="color:blue">${estimatedWeight}</span> /
                       <span style="color:blue">${weight}</span>`
            }
          },
          {
            headerName: this.$t('SeaExport.Cubage') + '(CBM)', field: 'cubage', width: 150,
            cellRenderer: (item) => {
              const { data } = item
              const estimatedCubage = ColumnUtils.number3ColumnLabelFunc(data.estimatedCubage)
              const cubage = ColumnUtils.number3ColumnLabelFunc(data.cubage)
              return `<span style="color:blue">${estimatedCubage}</span> /
                       <span style="color:blue">${cubage}</span>`
            }
          },
          {
            headerName: this.$t('SeaExport.Supplier'),
            field: 'supplierId',
            colId: 'supplierId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('SeaExport.Anufacturer'),
            field: 'producerId',
            colId: 'producerId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          }
        ]
      },
      console: {
        gridOptions: {
          rowSelection: 'multiple'
        },
        gridApi: {},
        rowData: [],
        columnDefs: [
          {
            headerName: '', width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true,
            checkboxSelection: (item) => {
              const { data } = item
              if (!data.poNo) {
                return false
              }
              return true
            }
          },
          { headerName: this.$t('SeaExport.OrderNo2'), field: 'poNo', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerSize'), field: 'eqSize', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerRule'), field: 'eqType', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 100 },
          { headerName: this.$t('SeaExport.ContainerNo'), field: 'containerNo', width: 150 },
          {
            headerName: this.$t('SeaExport.Supplier'),
            field: 'supplierId',
            colId: 'supplierId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Source'), field: 'source', width: 150 }
        ]
      },
      totalDesc: { // 合计汇总
        estimatedTotalPackings: 0,
        totalPackings: 0,
        estimatedTotalCubages: 0,
        totalCubages: 0,
        estimatedTotalWeight: 0,
        totalWeight: 0
      },
      totalLabel: { // 合计汇总label
        TotalPacking: this.$t('SeaExport.TotalPacking') + ':',
        TotalCubage: this.$t('SeaExport.TotalCubage') + ' CBM:',
        TotalWeight2: this.$t('SeaExport.TotalWeight2') + 'KGS:'
      },
      selectOrderWindow: { // 选择货物弹框
        visible: false,
        goodsMode: SystemConstants.FCL_TYPE.code
      },
      SystemConstants
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        await this.queryFcl()
        await this.queryLcl()
        await this.queryConsole()
        if (this.fcl.rowData.length > 0) {
          this.selectOrderWindow.goodsMode = SystemConstants.FCL_TYPE.code
        } else if (this.lcl.rowData.length > 0) {
          this.selectOrderWindow.goodsMode = SystemConstants.LCL_TYPE.code
        } else {
          this.selectOrderWindow.goodsMode = SystemConstants.CONSOLE_TYPE.code
        }
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.fcl.rowData = []
        this.lcl.rowData = []
        this.console.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    async toQuery() {
      if (this.selectOrderWindow.goodsMode === SystemConstants.FCL_TYPE.code) {
        await this.queryFcl()
      } else if (this.selectOrderWindow.goodsMode === SystemConstants.LCL_TYPE.code) {
        await this.queryLcl()
      } else if (this.selectOrderWindow.goodsMode === SystemConstants.CONSOLE_TYPE.code) {
        await this.queryConsole()
      }
    },
    // 查询整箱
    async queryFcl() {
      this.loading = getLoading()
      await queryOrderListByContainerCargoDoc({ cargoDocUuid: this.cargoDoc.uuid, ediContainerUuid: this.containerInfo.uuid }).then(res => {
        this.fcl.rowData = res.data || []
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询拼箱
    async queryLcl() {
      this.loading = getLoading()
      const item = {}
      item.anyStr = this.containerInfo.uuid
      item.anyStr1 = this.cargoDoc.jobUuid
      item.anyStr2 = this.cargoDoc.uuid
      await queryPoPackageListWithTotalPoPackage(item).then(res => {
        const result = res.data
        const totalInfo = result.totalPoMap
        if (totalInfo) {
          this.totalDesc.estimatedTotalPackings = totalInfo.estimatedTotalPackings || 0
          this.totalDesc.totalPackings = totalInfo.totalPackings || 0
          this.totalDesc.estimatedTotalCubages = ColumnUtils.number3ColumnLabelFunc(totalInfo.estimatedTotalCubages)
          this.totalDesc.totalCubages = ColumnUtils.number3ColumnLabelFunc(totalInfo.totalCubages)
          this.totalDesc.estimatedTotalWeight = ColumnUtils.number3ColumnLabelFunc(totalInfo.estimatedTotalWeight)
          this.totalDesc.totalWeight = ColumnUtils.number3ColumnLabelFunc(totalInfo.totalWeight)
        }
        this.lcl.rowData = result.dataList || []
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询Console
    async queryConsole() {
      this.loading = getLoading()
      const payload = {
        cargoDocUuid: this.cargoDoc.uuid,
        ediContainerUuid: this.containerInfo.uuid,
        containerNo: this.containerInfo.containerNo,
        jobUuid: this.cargoDoc.jobUuid,
        bindBl: true // 存在绑定关联
      }
      await queryOrderListByConsoleContainer(payload).then(res => {
        this.console.rowData = res.data || []
      }).finally(() => {
        this.loading.close()
      })
    },
    // 选择货物
    chooseGoodsBtnClickHandler() {
      this.selectOrderWindow.visible = true
    },
    // 移除订单
    removeOrderBtnHandler() {
      if (this.selectOrderWindow.goodsMode === SystemConstants.FCL_TYPE.code) {
        const rows = this.fcl.gridApi.getSelectedRows()
        if (rows.length === 0) {
          throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
        }
        this.loading = getLoading()
        batchModifyEdiContainerPoInfo({ ediContainerUuid: rows[0].ediContainerUuid, dataType: SystemConstants.FCL_TYPE.code }).then(res => {
          this.$message.success(this.$t('Message.RemovedSuccesfully'))
          this.reloadTable()
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.selectOrderWindow.goodsMode === SystemConstants.LCL_TYPE.code) {
        const rows = this.lcl.gridApi.getSelectedRows()
        if (rows.length === 0) {
          throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
        }
        const selUsages = Array.from(rows, p => p.poPackageUuid)
        if (selUsages && selUsages.length > 0) {
          // EDIContainer.removePoInfo(selUsages, removeResultHandler, faultHandler);
          this.loading = getLoading()
          batchRemoveEdiContainerPackage({ keys: selUsages }).then(res => {
            this.$message.success(this.$t('Message.RemovedSuccesfully'))
            this.reloadTable()
          }).finally(() => {
            this.loading.close()
          })
        } else {
          this.$message.warning(this.$t('SeaExport.removeGoodsTips'))
        }
      } else if (this.selectOrderWindow.goodsMode === SystemConstants.CONSOLE_TYPE.code) {
        const rows = this.console.gridApi.getSelectedRows()
        if (rows.length === 0) {
          throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
        }
        this.loading = getLoading()
        const poUuids = []
        for (const row of rows) {
          poUuids.push(row.uuid)
        }
        batchModifyEdiContainerPoInfo({ poUuids: poUuids, dataType: SystemConstants.CONSOLE_TYPE.code }).then(res => {
          this.$message.success(this.$t('Message.RemovedSuccesfully'))
          this.reloadTable()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    reloadTable() {
      this.toQuery()
    },
    saveHandler() {
      if (this.selectOrderWindow.goodsMode !== SystemConstants.LCL_TYPE.code) {
        this.innerVisible = false
        return
      }
      // CargoDoc.savePackageInfo(_tradeDetailValue.cargoDocUuid, saveResultHandler, faultHandler);
      this.loading = getLoading()
      savePackageInfo({ anyStr: this.cargoDoc.uuid }).then(res => {
        this.$emit('callBackFun')
        this.innerVisible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    onFclGridReady(params) {
      this.fcl.gridApi = params.api
    },
    onLclGridReady(params) {
      this.lcl.gridApi = params.api
    },
    onConsoleGridReady(params) {
      this.console.gridApi = params.api
    }
  }
}
</script>

<style lang="scss" scoped>
.triggers{
  justify-content: space-between !important;
  .calculation{
    padding: 0 20px !important;
    span{
      margin-left: 5px;
    }
  }
}
</style>

